// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a9-0";
export var optionCard = "_a9-1";